import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import moment from 'moment';

export function NoSameDateValidator(startControl: AbstractControl): ValidatorFn {
  return (endControl: AbstractControl): ValidationErrors | null => {
    const start = startControl.value;
    const end = endControl.value;

    if (!start || !end) return null;

    const isSameDay = moment(start).isSame(end, 'day');

    return isSameDay ? { sameDateNotAllowed: true } : null;
  };
}
